const ft = {
  venueLocal(val){
    let str = val.split(',');
    return str[1]+"-"+str[2];
  },
  char10(val){
    if(val.length < 20){
      return val;
    }
    return val.substr(0,20) + "...";
  },
  char50(val){
    if(val.length < 50){
      return val;
    }
    return val.substr(0,50) + "...";
  },
  role(val){
    let array = val.split(",");

    if(array.length>3){
      array.length = 3;
      return array.join(" / ")
    } else {
      return array.join(" / ")
    }
  },
  formatDate(val){
    if(val == null){
      return '-'
    }
    if(val == '未填写'){
      return val
    }
    var date =  new Date(val);
    var y = 1900+date.getYear();
    var m = "0"+(date.getMonth()+1);
    var d = "0"+date.getDate();
    return y+"-"+m.substring(m.length-2,m.length)+"-"+d.substring(d.length-2,d.length);
  },
  formatDateDot(val){
    var date =  new Date(val);
    var y = 1900+date.getYear();
    var m = date.getMonth()+1;
    var d = date.getDate();
    return y+"."+m+"."+d;
  },
  teamSize(val){
    if(val == 1){
      return '10人以内';
    } else if(val == 2){
      return '10-50人';
    } else if(val == 3){
      return '50人以上';
    }
  },
  unit(val){
    if(val <= 9999){
      return parseInt(val);
    }else if (val <=99999999){
      return parseInt(val/10000) + '万+';
    }else {
      return parseInt(val/100000000) + '亿+';
    }
  },
  budget(val){
    if(val == 1){
      return "5000以内";
    } else if(val == 2){
      return "5000-10000";
    } else if(val == 3){
      return "10000-50000";
    } else if(val == 4){
      return "50000-100000";
    } else {
      return "100000以上";
    }
  },
  length(val){
    if(val == 1){
      return "30秒以内";
    } else if(val == 2){
      return "30-60秒";
    } else if(val == 3){
      return "60-120秒";
    } else {
      return "120秒以上";
    }
  },
  bankCard(val){
    var strlen = val.length;
    return val.replace(/^(.{0})(?:\d+)(.{4})$/,"$1****-****-****-***-$2");
  },
  phoneCard(val){
    var strlen = val.length;
    return val.replace(/^(.{3})(?:\d+)(.{3})$/,"$1******$2");
  },
  ppaType(val){
    var str;
    if(val<4){
      str = "待沟通";
    } else if(val<5){
      str = "待签署";
    } else if(val == 5){
      str = "待支付策划费";
    } else if(val > 5 && val < 10){
      str = "策划中";
    } else if(val == 10){
      str = "待确认策划方案";
    } else if(val == 11){
      str = "待支付拍摄费";
    } else if(val > 11 && val < 21){
      str = "拍摄中";
    } else if(val == 21){
      str = "待支付尾款";
    } else if(val == 22){
      str = "已完成";
    } else if(val == 23){
      str = "已关闭";
    }
    return str;
  },
  version(val){
    var str;
    switch (val){
      case 0:
        str = "第一版";
        break;
      case 1:
        str = "第二版";
        break;
      case 2:
        str = "第三版";
        break;
      case 3:
        str = "第四版";
        break;
      default:
        str = "请选择版本";
        break;
    }
    return str;
  },
  yuan(val){
    return (val/100).toFixed(2);
  },
  ppbType(val){
    var str;
    if(val<14){
      str = "待加入";
    } else if(val>13 && val < 22){
      str = "进行中";
    } else if(val == 22){
      str = "已完成";
    } else if(val == 23){
      str = "已关闭";
    }
    return str;
  }
}

export default ft;



// WEBPACK FOOTER //
// ./src/filters/filters.js